import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { getImageSrc } from '@utils/fn';
import { eventTimeFormat } from '@utils/time';
import { useTranslation } from 'react-i18next';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface TitlePageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const TitlePage = ({ event, footer }: TitlePageProps) => {
  const { t } = useTranslation();
  const imageUrls = [
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_01.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_02.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_03.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_04.png',
  ];

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View style={styles.leftColumn}>
        {/* First image column */}
        <View style={{ ...styles.imageColumnWrapper }}>
          <View key={`image-left-01`} style={styles.imageLeft1}>
            <SafeImage src={imageUrls[0]} style={styles.imageLeft1} />
          </View>

          <View key={`image-left-02`} style={styles.imageLeft2}>
            <SafeImage src={imageUrls[1]} style={styles.imageLeft2} />
          </View>
        </View>

        {/* Second image column */}
        <View
          style={{
            ...styles.imageColumnWrapper,
            position: 'relative',
            top: 25,
          }}
        >
          <View key={`image-left-02`} style={styles.imageRight1}>
            <SafeImage src={imageUrls[2]} style={styles.imageRight1} />
          </View>

          <View key={`image-left-04`} style={styles.imageRight2}>
            <SafeImage src={imageUrls[3]} style={styles.imageRight2} />
          </View>
        </View>
      </View>

      <View style={styles.rightColumn}>
        <SafeImage
          src={getImageSrc(event?.images?.logo)}
          style={styles.eventImage}
        />

        <View style={styles.textWrapper}>
          <Text style={styles.title}>{event?.description || ''}</Text>
          <Text style={styles.subtitle}>
            {eventTimeFormat(
              event?.start_date,
              event?.end_date,
              event?.language,
              event?.timezone
            )}
            {' | '}
            {event?.location?.name ? `${event?.location?.name}, ` : ''}
            {event?.location?.marker?.city
              ? `${event?.location?.marker?.city}, `
              : ''}
            {t(`countries.${event?.location?.marker?.country ?? ''}`)}
          </Text>
        </View>

        <View style={{ width: '100%', height: '100%' }}>{footer} </View>
      </View>
    </Page>
  );
};

export default TitlePage;
